import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchPlatformBundle, type PlatformBundle } from '../api/platform';

export const PLATFORM_QUERY_KEY = ['platform', 'bundle'] as const;

export function usePlatform(): UseQueryResult<PlatformBundle, Error> {
  return useQuery({
    queryKey: PLATFORM_QUERY_KEY,
    queryFn: fetchPlatformBundle,
    staleTime: Infinity,
  });
}
